import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {hAreaCodeEnum} from 'hiya-common/src/reducers/env'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum TypeEnum {
  全部 = 0,
  高等级 = 1,
  低等级 = 2,
}

// [聊天分监控榜单] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156934761
export const homepage = createAsyncThunk(
  'Saada/live/hiya_socialize/chat_score_rank',
  async (arg: {area_code: hAreaCodeEnum; type: TypeEnum}, store: any) => {
    const resp = await http.post('/live/hiya_socialize/chat_score_rank', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// [聊天分详情] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156934949
export const detail = createAsyncThunk(
  'Saada/live/hiya_socialize/chat_score_detail',
  async (arg: {mid: number; type: 0 | 1}, store: any) => {
    const resp = await http.post('/live/hiya_socialize/chat_score_detail', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  rank?: {
    mid: number
    avatar: string
    level_str: string
    total_votes: number
    vote_user_num: number
    session_num: number
    praise_rate: string
    new_score: string
    old_score: string
    new_rank: number
    old_rank: number
    pearl: number
  }[]
  new_score_list?: {
    mid: number
    session_from_weights: string
    vote_time_coefficient: string
    action_votes: string
    session_round: number
    vote_type: string
    result_votes: string
  }[]
  old_score_list?: {
    mid: number
    user_weights: string
    chat_from_coefficient: string
    action_votes: string
    session_round: number
    vote_type: string
    result_votes: string
  }[]
}

const initialState: InitialStateType = {}

export const ChatRankSlice = createSlice({
  name: 'Animal_Wolf',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {rank: action.payload?.list || []})
    })
    builder.addCase(detail.fulfilled, (state, action) => {
      Object.assign(state, {
        new_score_list: action.payload?.new_score_list || [],
        old_score_list: action.payload?.old_score_list || [],
      })
    })
  },
})
export default ChatRankSlice.reducer
export const ChatRankActions = ChatRankSlice.actions

export const useChatRankState = () => {
  const data = useSelector((state) => {
    return state.Animal_Wolf
  })
  return data
}
